import React from 'react';

export default function StoreSupport() {
  return (
    <main style={{ display: 'flex', justifyContent: 'center' }}>
      <style>{`
        /* Scoped styles for StoreSupport */
        .store_support { margin-top: 40px; }
        .store_support * { font-size: 17px !important; }
        .store_support .tit_01 { font-size: 31px !important; line-height: 31px !important; }
        .store_support .tit_02 { font-size: 23px !important; line-height: 29px !important; }
        .store_support ul, .store_support ol { line-height: 27px !important; }
        .support_hero { background: linear-gradient(180deg,#f7f9fb 0%, #ffffff 100%); border:1px solid #eef2f6; padding:28px 24px; border-radius:14px; display:flex; align-items:center; justify-content:space-between; gap:20px; }
        .support_hero_text { max-width: 780px; }
        .support_actions { display:flex; gap:10px; margin-top:12px; }
        .support_btn { padding:12px 18px; border-radius:10px; border:1px solid #e5e8eb; background:#fff; cursor:pointer; }
        .support_btn_primary { background:#ff4400; color:#fff; border-color:#ff4400; }
        .support_badge { display:inline-block; background:#eaf3ff; color:#004368; padding:6px 10px; border-radius:999px; font-size:14px !important; }
        .support_section { padding:22px 20px; border:1px solid #eef2f6; border-radius:12px; background:#fff; }
        .support_cards { display:grid; grid-template-columns: repeat(5, minmax(0,1fr)); gap:12px; }
        .support_card { border:1px solid #eef2f6; border-radius:12px; padding:16px; background:#fff; box-shadow:0 2px 8px rgba(0,0,0,.03); }
        .support_card h4 { font-size:18px !important; margin:6px 0 8px; }
        .support_card small { color:#777; font-size:14px !important; }
        .support_checklist { padding-left: 18px; }
        .support_checklist li { list-style:'✅ '; margin-left:12px; padding-left:10px; }
        .support_notice { background:#fff7ed; border:1px solid #fde4cc; color:#7a3a00; padding:14px 16px; border-radius:12px; }
        .support_link { color:#004368; text-decoration:underline; }
        .support_gallery { display:grid; grid-template-columns:1fr; gap:12px; }
        .support_gallery img { width:100%; border:1px solid #eee; border-radius:10px; }
        .support_table { border:1px solid #eef2f6; border-radius:12px; overflow:hidden; }
        .support_table_row { display:flex; padding:12px 14px; border-top:1px solid #eef2f6; }
        .support_table_row:first-child { border-top:none; background:#f9fbfd; font-weight:600; }
        .support_table_row > div { flex:1; }
        .support_cta { text-align:center; padding:18px; }
        .support_cta .support_btn_primary { padding:14px 22px; font-size:18px !important; }
        @media(max-width: 1024px){ .support_cards{ grid-template-columns: repeat(2, minmax(0,1fr)); } }
        @media(max-width: 600px){ .support_cards{ grid-template-columns: 1fr; } }
      `}</style>
      <section className="contants_box store_support">
        {/* Hero */}
        <div className="support_hero">
          <div className="support_hero_text">
            <div className="support_badge">내기프트 상점 지원</div>
            <h2 className="tit_01" style={{ marginTop: 10 }}>
              상점 개설, 쉽고 빠르게 시작하세요
            </h2>
            <p className="font_gray" style={{ marginTop: 10 }}>
              관리자 정보 입력 → 인증 및 주소 → 상점 정보/로고 → 정산 정보 → QR
              생성까지, 단계를 따라오면 바로 판매를 시작할 수 있어요.
            </p>
            <div className="support_actions">
              <a
                className="support_btn support_btn_primary"
                href="/user-signup"
              >
                회원가입으로 상점 등록 시작
              </a>
              <a className="support_btn" href="#guide">
                상점 등록 가이드 보기
              </a>
            </div>
          </div>
        </div>

        {/* 필수 체크리스트 */}
        <article
          id="guide"
          className="support_section"
          style={{ marginTop: 14 }}
        >
          <h3 className="tit_02">필수 체크리스트</h3>
          <ul className="support_checklist" style={{ marginTop: 10 }}>
            <li>사업자등록번호, 사업자명, 대표자명, 이메일, 전화번호 준비</li>
            <li>상점 로고 이미지(최대 3MB, jpg/jpeg/png/gif) 준비</li>
            <li>고객센터 연락처와 상점 주소 확인</li>
          </ul>
        </article>

        {/* 등록 절차 카드 */}
        <article className="support_section" style={{ marginTop: 14 }}>
          <h3 className="tit_02">상점 등록 절차</h3>
          <div className="support_cards" style={{ marginTop: 12 }}>
            <div className="support_card">
              <div>🧑‍💼</div>
              <h4>관리자 정보</h4>
              <small>아이디, 비밀번호, 이름, 생년월일, 이메일 등 입력</small>
            </div>
            <div className="support_card">
              <div>🔐</div>
              <h4>인증 및 주소</h4>
              <small>이메일/전화번호 인증 후 주소 입력</small>
            </div>
            <div className="support_card">
              <div>🏪</div>
              <h4>상점 정보/로고</h4>
              <small>상점명, 로고 이미지 업로드</small>
            </div>
            <div className="support_card">
              <div>💳</div>
              <h4>정산 정보</h4>
              <small>은행/계좌/예금주 등록</small>
            </div>
            <div className="support_card">
              <div>🔗</div>
              <h4>QR 생성</h4>
              <small>상점 QR을 생성해 손쉽게 공유</small>
            </div>
          </div>
        </article>

        {/* 예시 화면 */}
        <article className="support_section" style={{ marginTop: 14 }}>
          <h3 className="tit_02">예시 화면</h3>
          <div className="support_gallery" style={{ marginTop: 12 }}>
            <img
              src="/images/내기프트 회원가입.png"
              alt="내기프트 회원가입 화면 예시"
            />
            <img
              src="/images/내기프트 회원가입 상점정보란.png"
              alt="내기프트 상점정보 입력 예시"
            />
          </div>
        </article>

        {/* 결제 연동 및 업종 확인 */}
        <article className="support_section" style={{ marginTop: 14 }}>
          <h3 className="tit_02">결제 연동 및 업종 확인</h3>
          <div className="support_notice" style={{ marginTop: 10 }}>
            내기프트 결제는 토스페이먼츠 연동으로 진행됩니다. 원활한 심사/연동을
            위해 정보 입력을 정확히 해 주세요.
          </div>
          <p style={{ marginTop: 10 }}>
            온라인 판매가 가능한 업종인지 확인하셨나요? 카드사에 입점할 수 없는
            <a
              className="support_link"
              href="https://tosspublic.notion.site/113ab653d9d849ac86748ea18834d806"
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              등록유의업종
            </a>
            여부를 꼭 확인해 주세요.
          </p>
        </article>

        {/* 유의업종 필요 서류 */}
        <article className="support_section" style={{ marginTop: 14 }}>
          <h3 className="tit_02">유의업종 필요 서류 안내</h3>
          <p style={{ marginTop: 8 }}>
            유의업종 필요 서류를 준비하셨나요? 일반주류, 의약품 등 일부
            유의업종의 경우 심사를 위해 제출해야 하는 구비서류가 있어요. 업종에
            따라 필요한 서류와 특이사항을 확인하고 준비해 주세요.
          </p>
          <div style={{ marginTop: 12 }}>
            <img
              src="/images/유의업종 필요 서류.webp"
              alt="유의업종 필요 서류 안내"
              className="support_gallery"
              style={{
                width: '100%',
                border: '1px solid #eee',
                borderRadius: 10,
              }}
            />
          </div>
        </article>

        {/* 금액 제한 */}
        <article className="support_section" style={{ marginTop: 14 }}>
          <h3 className="tit_02">상품 금액 제한 안내</h3>
          <p style={{ marginTop: 8 }}>
            환금성 및 특정 업종의 경우 이용약관에 따라 상품 금액을 제한하고
            있어요. 업종에 따라 제한 금액이 달라지기 때문에 아래 내역에 맞게
            상품 금액이 설정되어 있는지 확인해 보세요.
          </p>
          <div className="support_table" style={{ marginTop: 12 }}>
            <div className="support_table_row">
              <div>업종</div>
              <div>제한 기준</div>
            </div>
            <div className="support_table_row">
              <div>충전 서비스</div>
              <div>1일 최대 결제 금액 5만 원 미만</div>
            </div>
            <div className="support_table_row">
              <div>상품권</div>
              <div>1개월 최대 결제 금액 100만 원 미만</div>
            </div>
            <div className="support_table_row">
              <div>게임</div>
              <div>1일 최대 결제 금액 5만 원 미만</div>
            </div>
          </div>
          <p className="font_gray" style={{ marginTop: 8 }}>
            ✅ 500만 원 이상 고가 상품의 경우, 카드심사를 통과하지 못하거나
            별도의 심사 협의가 발생할 수 있어 3~4일 정도 더 걸릴 수 있어요.
          </p>
        </article>

        {/* CTA */}
        <div className="support_cta">
          <a className="support_btn support_btn_primary" href="/user-signup">
            지금 상점 등록 시작하기
          </a>
        </div>
      </section>
    </main>
  );
}
 